module.exports = {
    config: require('./config'),
    procedures: {
        app_content_create: {
            definition: require('./app_content_create/definition.json'),
            mock_data: require('./app_content_create/mock_data.json')
        },
        app_content_read: {
            definition: require('./app_content_read/definition.json'),
            mock_data: require('./app_content_read/mock_data.json')
        },
        app_content_update: {
            definition: require('./app_content_update/definition.json'),
            mock_data: require('./app_content_update/mock_data.json')
        },
        file_create: {
            definition: require('./file_create/definition.json'),
            mock_data: require('./file_create/mock_data.json')
        },
        file_on_server_create: {
            definition: require('./file_on_server_create/definition.json'),
            mock_data: require('./file_on_server_create/mock_data.json')
        },
        file_render_read: {
            definition: require('./file_render_read/definition.json'),
            mock_data: require('./file_render_read/mock_data.json')
        },
        file_read: {
            definition: require('./file_read/definition.json'),
            mock_data: require('./file_read/mock_data.json')
        },
        file_update: {
            definition: require('./file_update/definition.json'),
            mock_data: require('./file_update/mock_data.json')
        },
        file_list: {
            definition: require('./file_list/definition.json'),
            mock_data: require('./file_list/mock_data.json')
        },
        mapsample_list: {
            definition: require('./mapsample_list/definition.json'),
            mock_data: require('./mapsample_list/mock_data.json')
        },
        template_create: {
            definition: require('./template_create/definition.json'),
            mock_data: require('./template_create/mock_data.json')
        },
        template_instance_create: {
            definition: require('./template_instance_create/definition.json'),
            mock_data: require('./template_instance_create/mock_data.json')
        },
        template_instance_list: {
            definition: require('./template_instance_list/definition.json'),
            mock_data: require('./template_instance_list/mock_data.json')
        },
        template_list: {
            definition: require('./template_list/definition.json'),
            mock_data: require('./template_list/mock_data.json')
        },
        template_read: {
            definition: require('./template_read/definition.json'),
            mock_data: require('./template_read/mock_data.json')
        },
        template_update: {
            definition: require('./template_update/definition.json'),
            mock_data: require('./template_update/mock_data.json')
        },
        template_data_key_create: {
            definition: require('./template_data_key_create/definition.json'),
            mock_data: require('./template_data_key_create/mock_data.json')
        },
        template_data_key_update: {
            definition: require('./template_data_key_update/definition.json'),
            mock_data: require('./template_data_key_update/mock_data.json')
        },
        template_data_key_list: {
            definition: require('./template_data_key_list/definition.json'),
            mock_data: require('./template_data_key_list/mock_data.json')
        },
        transformation_list: {
            definition: require('./transformation_list/definition.json'),
            mock_data: require('./transformation_list/mock_data.json')
        },
        transformation_rule_action_list: {
            definition: require('./transformation_rule_action_list/definition.json'),
            mock_data: require('./transformation_rule_action_list/mock_data.json')
        },
        transformation_rule_list: {
            definition: require('./transformation_rule_list/definition.json'),
            mock_data: require('./transformation_rule_list/mock_data.json')
        }
    }
};